export const propertyEndReasoon = [
    {
        value: "Owner Moved In"
    },
    {
        value: "Foreclosure"
    },
    {
        value: "Owner Self-Managing"
    },
    {
        value: "Owner Sold"
    },
    {
        value: "Maintenance"
    },
];

export const managementCompanies = [
    {
        value: "405 Property Group"
    },
    {
        value: "Emergency Work Order Line"
    },
    {
        value: "Rasul Muhammad"
    },
    {
        value: "Baryaan Lee"
    },
];